(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limited-stock-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var popups = document.querySelectorAll('.ls-popup-overlay');
    popups.forEach(function (popup) {
      var delay = parseInt(popup.dataset.delay, 10) || 5000;
      setTimeout(function () {
        popup.hidden = false;
        popup.classList.add('is-active');
      }, delay);
      popup.addEventListener('click', function (e) {
        if (e.target.closest('.ls-popup-cta-link')) return;
        if (e.target === popup || e.target.hasAttribute('data-ls-close')) {
          popup.classList.remove('is-active');
          popup.hidden = true;
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-active')) {
          popup.classList.remove('is-active');
          popup.hidden = true;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
